export const environment = {
  production: false,
  eliquaRestURL: 'https://stamou.uat.qivos.net/ci-stamou-UAT/rest/v1/',
  clientName: 'stamou',
};
